import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    load: false,
    modal: '',
    crm: [],
    objMedico: '',
    objUnidade: '',

    dataAgendamento: '',

    novoIdPaciente: '',

    idPerfil: ''
  },
  getters: {
    getModal: state => state.modal,
    getLoad: state => state.load,
    getCrm: state => state.crm,
    getObjMedico: state => state.objMedico,
    getObjUnidade: state => state.objUnidade,

    getData: state => state.dataAgendamento,

    getNovoId: state => state.novoIdPaciente,

    getIdPerfil: state => state.idPerfil,
  },
  mutations: {
    setModal(state, payload){
      state.modal = payload
    },
    setLoad(state, payload){
      state.load = payload
    },
    setCrm(state, payload){
      state.crm = payload
    },
    setObjMedico(state, payload){
      state.objMedico = payload
    },
    setObjUnidade(state, payload){
      state.objUnidade = payload
    },

    setDataAgendamento(state, payload){
      state.dataAgendamento = payload
    },

    setNovoId(state, payload){
      state.novoIdPaciente = payload
    },

    setIdPerfil(state, payload){
      state.idPerfil = payload
    }
  },
  actions: {
  }
})
